module.exports = "https://www.gc-pro.gnp.com.mx/6f896b47ada24e8110dcb1236932ecbd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/liveHelp.svg
// module id = 8144
// module chunks = 0